@if (inited) {
    <div class="flex-col height100p">
        <sm-toolbar>
            @if (doc.status != 'Abgeschlossen') {
                <button pButton icon="fas fa-check" severity="success" label="Fertigstellen" (click)="finish()"></button>
            }
            <button pButton icon="fas fa-times" severity="danger" label="Abbrechen" (click)="cancel()"></button>
            @if (doc.status != 'Abgeschlossen') {
                <button pButton icon="fas fa-check" label="Zwischenstand speichern" (click)="save()"></button>
            }
            <button pButton icon="fas fa-eye" label="Vorschau" (click)="preview()"></button>
            <button pButton icon="fas fa-print" label="Drucken" (click)="print()"></button>
            <p-splitButton label="Vorlage" [model]="templateMenuItems"></p-splitButton>
            <p-splitButton label="Rechnung kopieren" [model]="copyInvoiceMenuItems"></p-splitButton>
            @if (app.isAdmin()) {
                <button pButton icon="fas fa-plus" severity="warning" label="Dokumentdaten anzeigen (Admin)" (click)="displayDocData()"></button>
                <button pButton icon="fas fa-save" severity="warning" label="SAGE/Mail/Ablage (Admin)" (click)="toService()"></button>
            }
        </sm-toolbar>
        <p-tabView class="flex-item-fill height100p full-height">
            <p-tabPanel header="Informationen bearbeiten">
                <p-splitter class="height100p" [style]="{'overflow-y': 'auto'}" styleClass="mb-5">
                    <ng-template pTemplate>
                        <sm-form #formComponent class="p-3 width100p" [form]="f"></sm-form>            
                    </ng-template>
                    <ng-template pTemplate>
                        <p-panel class="width100p full-height" [style]="{'height': splitterHeight, 'min-height': 'calc(100vh - 170px)'}" header="Vorschau">
                            <div *ngIf="generated != null && generated.missingFields.length > 0">
                                Warnung: Die folgenden Felder in der Vorlage konnten nicht gefüllt werden: {{_Utils.arrayItemsToString(generated.missingFields)}}
                            </div>
                            <div class="height100p">
                                <ng2-pdfjs-viewer #pdfViewer (onDocumentLoad)="pdfLoaded()"></ng2-pdfjs-viewer>
                            </div>
                        </p-panel>
                    </ng-template>
                </p-splitter>
            </p-tabPanel>
            <p-tabPanel header="Rechnungsanhänge">
                <ng-template pTemplate="header">
                    Rechnungsanhänge
                    @if (doc.attachments?.length > 0) {
                        <span class="ml-2 p-badge">{{doc.attachments.length}}</span>
                    }
                </ng-template>
                <div class="flex-col height100p">
                    <sm-toolbar class="flex-item-fixed">
                        <p-button [disabled]="doc.status == 'Abgeschlossen'" icon="fas fa-plus" [label]="app.t('wfs.attachDocument')" (onClick)="attachDocument()">
                        </p-button>
                    </sm-toolbar>
                    <div class="flex-item-fill flex-row-split">
                        <sm-table2 #attachmentsTableComponent class="width50p height100p" [data]="attachmentsTable" [allowRemoveRow]="doc.status != 'Abgeschlossen'" [selection]="selectedAttachment" [performRemoveTableRow]="_removeAttachment" (onRowSelect)="selectAttachment($event)">
                        </sm-table2>
                        <ng2-pdfjs-viewer class="width50p" #pdfViewerAttachment></ng2-pdfjs-viewer>
                    </div>
                </div>
            </p-tabPanel>
            
        </p-tabView>
        
    </div>
}
